/**
 * Feature flags — per-pilot opt-in for the Re-flow contractor port.
 *
 * Resolution order (first match wins):
 *   1. localStorage override  → `localStorage.setItem('cs_ff_contractorWorkspace','on'|'off')`
 *   2. env build flag         → REACT_APP_CONTRACTOR_WORKSPACE = 'on' | 'off'
 *   3. pilot company allow-list (below)
 *   4. default OFF in production, ON in development so the new screens are
 *      easy to preview locally.
 *
 * Keep every ticket behind a flag so the Harvey Dunn / Time Consultancy pilot
 * can opt in without exposing the work-in-progress to every contractor.
 */

// Company codes (contractor company `code`) enrolled in the pilot.
const PILOT_COMPANY_CODES = ['CS-CON-4821']; // Apex Access Ltd (Harvey Dunn pilot)

const readOverride = (key) => {
  try {
    return typeof window !== 'undefined' ? window.localStorage.getItem(key) : null;
  } catch {
    return null;
  }
};

/**
 * @param {{ companyCode?: string }} [ctx]
 * @returns {boolean}
 */
export const isContractorWorkspaceEnabled = (ctx = {}) => {
  const override = readOverride('cs_ff_contractorWorkspace');
  if (override === 'on') return true;
  if (override === 'off') return false;

  const envFlag = process.env.REACT_APP_CONTRACTOR_WORKSPACE;
  if (envFlag === 'on') return true;
  if (envFlag === 'off') return false;

  const code = ctx.companyCode || (typeof window !== 'undefined' ? readOverride('companyCode') : null);
  if (code && PILOT_COMPANY_CODES.includes(code)) return true;

  // The workspace is now the default contractor experience. Set the localStorage
  // override or REACT_APP_CONTRACTOR_WORKSPACE='off' to fall back to the classic dashboard.
  return true;
};

export const FEATURE_FLAGS = {
  contractorWorkspace: 'cs_ff_contractorWorkspace',
};

const featureFlags = { isContractorWorkspaceEnabled, FEATURE_FLAGS };
export default featureFlags;
